import { OnInit, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isString } from '../../core/utils/strings/is-string';
import { isDevModeAndNoData } from './helper/is-dev-mode-and-no-data';
import { getExtension } from '../../core/utils/strings/get-extension';
import { isInPictureDataNotFallback } from './helper/is-in-picture-data-not-fallback';
// REVIEW: Extract interfaces to separate file
// REVIEW: Move to lib/core/utils
var PictureComponent = /** @class */ (function () {
    function PictureComponent(sanitizer, elementRef) {
        this.sanitizer = sanitizer;
        this.elementRef = elementRef;
        this.scale = 100;
        this.pictureData = null;
        this.isLazyLoading = false;
    }
    Object.defineProperty(PictureComponent.prototype, "hostStyle", {
        get: function () {
            if (!!this.ratio) {
                return this.sanitizer.bypassSecurityTrustStyle("padding-bottom: " + (1 / this.ratio) * 100 + "%;\n        display: block;\n        height: 0;\n        overflow: hidden;\n        position: relative;"); //REVIEW: Remove hardcode
            }
        },
        enumerable: true,
        configurable: true
    });
    // REVIEW: Don't use underscore. If it's private use modifier private instead.
    PictureComponent.prototype.getHostElement = function () {
        return this.elementRef.nativeElement;
    };
    PictureComponent.prototype.hasHostAttributes = function () {
        var _this = this;
        var attributes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attributes[_i] = arguments[_i];
        }
        return attributes.some(function (attribute) { return _this.getHostElement().hasAttribute(attribute); });
    };
    PictureComponent.prototype.ngOnInit = function () {
        // REVIEW: Make condition as meaningful function.
        // It's hard to understand when that condition applied.
        if (isDevModeAndNoData(this.data, this.fallback))
            console.error("Please provide at least one of string or PictureData or fallback. In production will be used empty string as src therefore alt text will be used");
        if (this.hasHostAttributes('lazy')) {
            this.isLazyLoading = true;
        }
        if (this.data && !isString(this.data)) {
            this.pictureData = this.data;
        }
        if (this.data && isString(this.data)) {
            this.pictureData = {
                alt: '',
                src: this.data,
                sources: []
            };
        }
        if (this.fallback && !this.data) {
            this.pictureData = {
                alt: '',
                src: this.fallback,
                sources: []
            };
        }
        this.className = this.elementRef.nativeElement.className + " " + this.getImageExtension() + " " + (!!this.ratio ? 'picture--ratio' : '') + " " + (!isInPictureDataNotFallback(this.pictureData, this.fallback) && this.pictureData ? 'picture--fallback' : '');
        if (!this.fallback && !this.data) {
            this.className += 'picture--fail';
            return;
        }
        this.updateInlineStyles();
    };
    PictureComponent.prototype.getImageExtension = function () {
        // REVIEW: Make condition as meaningful function.
        // It's hard to understand when that condition applied.
        if (this.pictureData) {
            this.currentPictureExtension = getExtension(this.pictureData.src);
            return getExtension(this.pictureData.src);
        }
        return '';
    };
    PictureComponent.prototype.updateInlineStyles = function () {
        var width = 'auto';
        var maxWidth = '100%';
        if (this.scale < 100) {
            width = this.scale + "%";
        }
        this.style = { width: width, maxWidth: maxWidth };
    };
    PictureComponent.prototype.reset = function () {
        this.pictureData = null;
    };
    // REVIEW: Add type of event.
    PictureComponent.prototype.fallbackHandler = function (event) {
        // REVIEW: Please use hasOwnProperty check in such loops.
        if (isInPictureDataNotFallback(this.pictureData, this.fallback)) {
            this.className = !!this.currentPictureExtension
                ? this.className.replace(this.currentPictureExtension, getExtension(this.fallback))
                : this.className += " " + getExtension(this.fallback);
            this.className += ' picture--fallback';
            this.pictureData.sources = [];
            this.pictureData.src = this.fallback;
        }
        else {
            this.className = this.className.replace('picture--fallback', 'picture--fail');
            if (!this.className.includes('picture--fail')) {
                this.className += ' picture--fail';
            }
            this.reset();
        }
    };
    return PictureComponent;
}());
export { PictureComponent };
